'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');
var utils_HOC_withDeprecated_index = require('../../../utils/HOC/withDeprecated/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgTick = function (props) {
    var className = props.className;
    var svgProps = tslib_es6.__assign(tslib_es6.__assign({}, props), { className: '' });
    return (React__default['default'].createElement("div", { className: className },
        React__default['default'].createElement("svg", tslib_es6.__assign({ width: "100%", height: "100%", viewBox: "0 0 30 30", fill: "currentColor" }, svgProps),
            React__default['default'].createElement("path", { d: "M8.77 14.704l4.06 4.037-.002 1.053-4.578-4.55.52-.54zM21.962 9.75l.538.525-9.67 9.519v-1.053l9.132-8.991z" }))));
};
var TickIcon = utils_HOC_withDeprecated_index['default'](SvgTick, 'Normalized 20x20 CheckIcon icon available at /Icons/CheckIcon', new Date('2022-04-19'));

exports.default = TickIcon;
//# sourceMappingURL=index.js.map
